import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Institution } from "@gwc/datasources/gwc-api/types/institution.types";
import { Observable } from "rxjs";
import { CasualHireFormService } from "./casual-hire-form.service";

@Injectable({
    providedIn: 'root'
})
export class CasualHireFormInstitutionsResolver  {
    
    /**
     * Construcotr
     */
    constructor(
        private _casualHireFormService: CasualHireFormService
    ) { }

    
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Institution[]> {
        return this._casualHireFormService.getInstitutions();
    }
}